import { IJwtPayload } from "./commonClasses";

declare var angular: any;

module RolesService {

    export interface IRolesService {
        isAuthorizedForState: (state: angular.ui.IState) => boolean;
    }

    export class CRolesService implements IRolesService {
        constructor(
            protected GlobalApplicationData: any
        ) {
        }

        public loggedUserHasRole = (role: string): boolean => {
            let jwtPayload: IJwtPayload = this.GlobalApplicationData.jwtPayload;

            let authList: Array<string> = jwtPayload ? (jwtPayload.authorizations && jwtPayload.authorizations.length > 0 ? jwtPayload.authorizations : ["ROLE_BASE"]) : [];

            return authList.indexOf(role) >= 0;
        };

        public isAuthorizedForState = (state: angular.ui.IState): boolean => {
            let authorized = true;

            if (state.data && state.data.requiredRole) {
                authorized == this.loggedUserHasRole(state.data.requiredRole);
            }

            return authorized;
        };
    }

    angular.module("AdeMesApp").factory("RolesService", (GlobalApplicationData: any) => new RolesService.CRolesService(GlobalApplicationData));
}